import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { InitialsPipe } from '@app/shared/pipes/initials.pipe';
import { Integration } from '@shared/models/integrations.models';

@Component({
  selector: 'app-integration-favicon',
  standalone: true,
  templateUrl: './integration-favicon.component.html',
  imports: [CommonModule, InitialsPipe],
  styleUrls: ['./integration-favicon.component.scss'],
  host: {
    '[style.--integration-icon-size]': 'iconSize()',
    '[style.--integration-border-radius]': 'borderRadius()',
    '[style.--integration-border-color]': 'borderColor()',
  },
})
export class IntegrationFaviconComponent {
  integration = input.required<Integration>();

  iconSize = input<string>('1.5rem');
  borderRadius = input<string>('50%');
  borderColor = input<string>('var(--grey-grey-200)');
}
